export default "__VITE_ASSET__CCQIu1DA__"